import { IoClose } from "react-icons/io5";
import { resolveMediaUrl } from "../../../../utility/media";
import { useTranslation } from "react-i18next";

const ViewAgendaDetailsModal = ({ isOpen, onClose, agenda }) => {
    const {t} = useTranslation();

    if (!isOpen || !agenda) return null;

    return (
        <div className="staff-modal-overlay">
            <div className="staff-modal" style={{ width: '900px', maxWidth: '95%' }}>
                {/* Modal Header matching your existing style */}
                <div className="staff-modal-header" style={{ background: '#a0adf1', borderBottom: '1px solid #979797' }}>
                    <div className="staff-modal-title" style={{ color: 'white', width: '100%', textAlign: 'center' }}>
                        {t('pageTitles.agendaDetails')}
                    </div>
                    <button className="staff-modal-close" onClick={onClose} style={{ color: 'white' }}>
                        <IoClose />
                    </button>
                </div>

                <div className="staff-form-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                    {/* Meeting Information Header */}
                    <div className="flex flex-col gap-2 mb-6 mt-2">
                        <div className="md:flex items-center gap-4">
                            <label className="staff-modal-label" style={{ marginBottom: 0 }}>
                                {t('forms.meeting.meetingTitle')}
                            </label>
                            <span className="text-sm font-bold text-gray-800">
                                {agenda.meetingName}
                            </span>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label" style={{ marginBottom: 0 }}>
                                {t('forms.meeting.meetingDate')} :
                            </label>
                            <span className="text-sm text-gray-600">
                                {agenda.meetingDate || "N/A"}
                            </span>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label" style={{ marginBottom: 0 }}>
                                {t('forms.meeting.meetingPlace')} :
                            </label>
                            <span className="text-sm text-gray-600">
                                {agenda.meetingLocation || "N/A"}
                            </span>
                        </div>
                    </div>

                    {/* Agendas Table - Grouped view of multiple items */}
                    <div className="border border-black rounded-sm overflow-hidden mx-auto mb-4" >
                        <table className="w-full text-sm border-collapse">
                            <thead>
                                <tr className="bg-gray-100 border-b border-black">
                                    <th className="p-2 text-center border-r border-black font-bold w-12">{t('tables.srNo')}</th>
                                    <th className="p-2 border-r border-black font-bold">{t('forms.agenda.agendaDescription')}</th>
                                    <th className="p-2 text-center font-bold w-48">{t('common.attachments')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {agenda.agendaItems && agenda.agendaItems.length > 0 ? (
                                    agenda.agendaItems.map((item, index) => (
                                        <tr key={item.id || index} className="border-b border-black last:border-0">
                                            <td className="p-2 text-center border-r border-black">{index + 1}</td>
                                            <td className="p-2 pl-4 text-left border-r border-black whitespace-pre-wrap">
                                                {item.agendaDescription}
                                            </td>
                                            <td className="p-2 text-center">
                                                {item.attachmentUrl ? (
                                                    <a 
                                                        href={resolveMediaUrl(item.attachmentUrl)} 
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                        className="text-blue-600 underline hover:text-blue-800 break-all"
                                                    >
                                                        {item.attachmentName || "View File"}
                                                    </a>
                                                ) : (
                                                    <span className="text-gray-400 italic">No File</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="p-4 text-center text-gray-500 italic">
                                            No agenda items found for this meeting.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer matching your Save button style */}
                <div className="staff-form-footer">
                    <button className="staff-btn-save" onClick={onClose}>
                        {t('common.close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewAgendaDetailsModal;